import common from '../common/consignado'

export default (proposal) => {
  const commonParameters = common()

  const installments = proposal?.installmentsNumber
  const simulated_value = proposal?.requestedLoanValue

  const payload = {
    installments,
    simulated_value,
    custom_path: '/emprestimo/consignado/com-oferta',
    ...commonParameters
  }

  return payload
}
